export default __webpack_public_path__ + "static/media/undraw_online_media_re_r9qv.12deda9a.svg";